<template>
  <div class="pie">
    <header>
      <h3>团队需求情况</h3>
      <span>(落点时间)</span>
    </header>
    <div ref="target" style="width: 100%; height: 300px"></div>
  </div>
</template>
<script>
import * as echarts from "echarts"
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
      globalMaxValue: 0,
    }
  },

  mounted() {
    this.myChart = echarts.init(this.$refs.target)
    this.renderChart()
    window.addEventListener("resize", this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    this.myChart && this.myChart.dispose()
  },

  methods: {
      // 获取所有团队value数组中的全局最大值
      getGlobalMaxValue(data) {
        if (!data || data.length === 0) return 0;
        
        // 收集所有value数组中的数字
        const allValues = data.reduce((acc, item) => {
          return acc.concat(item.value);
        }, []);
        
        // 返回所有数字中的最大值
        return Math.max(...allValues);
      },
      renderChart() {
        // 创建echarts雷达图配置
        const options = {
        tooltip: {
          trigger: "item",
          backgroundColor: "#3c3c3c",
          // 限制tooltip在图表容器内显示
          confine: true,
          // 设置tooltip的最大宽度
          maxWidth: 300,
          // 设置tooltip的内边距
          padding: 5,
          formatter: (params) => {

            // 定义各项指标的名称和描述文案
            const indicators = [
              { name: "按时完成率", desc: "团队在落点时间内完成需求的比例" }, // v5 §9-B：改比落点时间
              { name: "通过率", desc: "团队提交的素材一次性通过审核的比例" },
              { name: "拒绝率", desc: "团队提交的素材被拒绝次数的比例" },
              {
                name: "需求量占比",
                desc: "该团队承接的需求量占总工单需求量的比例",
              },
              {
                name: "工单超时率",
                desc: "团队承接的需求超过落点时间的比例", // v5 §9-B
              },
            ]

            // 构造tooltip内容：标题(团队名称，蓝色字体) + 各指标项
            // 调整样式，使内容更紧凑
            let content = `<div style="color: #67a4cc; font-weight: bold; margin-bottom: 5px;">${params.data.name}</div>`
              
              
            // 遍历指标数据，使用预定义的指标名称和描述
            params.data.value.forEach((value, index) => {
              if (indicators[index]) {
                // 调整行间距和字体大小，使内容更紧凑
                if (indicators[index].name === "需求量占比") {
                  content += `<div style="color: #b4b4b4;margin-bottom: 3px; font-size: 12px;font-weight: bold;display: flex;justify-content:space-between">
                              <div>${indicators[index].name}:</div>
                              <div style="color:#5f9f57">${value} %</div>
                            </div>`
                } else {
                  content += `<div style="color: #b4b4b4;margin-bottom: 3px; font-size: 12px;font-weight: bold;display: flex;justify-content:space-between">
                              <div>${indicators[index].name}:</div>
                              <div  style="color:#e19538">${value} %</div>
                            </div>`
                }
                content += `<div style="color: #8a8a8a; font-size: 11px; margin-bottom: 2px; padding-left: 5px;">${indicators[index].desc}</div>`
              }
            })

            return content
          },
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
          data: this.dataList.map((team) => team.name),
          textStyle: {
            fontSize: 12,
          },
          color: ["#557fee", "#53b686", "#e8a33b", "#dd554b", "#885ded"],
          // 添加滚动功能
          type: 'scroll',
          pageButtonGap: 5,
          pageIconSize: 12,
          pageButtonItemGap: 5,
          pageFormatter: '{current}/{total}'
        },
        radar: {
          indicator: [
            { name: "按时完成率",max:this.getGlobalMaxValue(this.dataList) },
            { name: "通过率",max:this.getGlobalMaxValue(this.dataList) },
            { name: "拒绝率",max:this.getGlobalMaxValue(this.dataList) },
            { name: "需求量占比",max:this.getGlobalMaxValue(this.dataList) },
            { name: "工单超时率",max:this.getGlobalMaxValue(this.dataList) },
          ],
          radius: "70%",
          splitArea: {
            areaStyle: {
              color: ["rgba(250, 250, 250, 0.2)", "rgba(240, 240, 240, 0.2)"],
            },
          },
        },
        series: [
          {
            name: "团队能力分析",
            type: "radar",
            data: this.dataList,
          },
        ],
      }
      
      // 设置图表配置
      this.myChart.setOption(options)
    },

    handleResize() {
      this.myChart && this.myChart.resize()
    },
  },
  watch: {
    dataList: {
      handler(newVal, oldVal) {
        this.renderChart()
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.pie {
  header {
    display: flex;
    align-items: center;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
}
</style>
